import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class BmarkFixingDefinition {
  public code: string = null;
  public softCutoffOffset: number = null;
  public hardCutoffOffset: number = null;
  public sweepTimeOffset: number = null;
  public spotWarnThresholds: Map<string, CubiqTS.BigNumber> = new Map<string, CubiqTS.BigNumber>();
  public spotAlertThresholds: Map<string, CubiqTS.BigNumber> = new Map<string, CubiqTS.BigNumber>();
  public fwdWarnThresholds: Map<string, CubiqTS.BigNumber> = new Map<string, CubiqTS.BigNumber>();
  public fwdAlertThresholds: Map<string, CubiqTS.BigNumber> = new Map<string, CubiqTS.BigNumber>();

  constructor(public fixingDefinitionImpl?: CubiqTS.BenchmarkFixingImpl) {
    if (fixingDefinitionImpl instanceof CubiqTS.BenchmarkFixingImpl) {
      this.code = fixingDefinitionImpl.benchmarkCd;
      this.softCutoffOffset = fixingDefinitionImpl.softCutoffOffset.toNumber() * 60 * 1000; // not in use
      this.hardCutoffOffset = fixingDefinitionImpl.hardCutoffOffset.toNumber() * 60 * 1000; // not in use
      this.sweepTimeOffset = fixingDefinitionImpl.sweepTimeOffset.toNumber() * 60 * 1000; // IN USE
      if (
        fixingDefinitionImpl.benchmarkPairConfigs &&
        fixingDefinitionImpl.benchmarkPairConfigs.length > 0
      ) {
        for (const pairCfg of fixingDefinitionImpl.benchmarkPairConfigs) {
          let key: string = pairCfg.base + pairCfg.nonBase;
          this.spotWarnThresholds.set(key, pairCfg.warningLevel);
          this.spotAlertThresholds.set(key, pairCfg.alertLevel);
          this.fwdWarnThresholds.set(key, pairCfg.fwdWarningLevel);
          this.fwdAlertThresholds.set(key, pairCfg.fwdAlertLevel);
        }
      }
    }
  }
}
